<template>
  <div  class="CxSplcSlHome">
    <div class="headerSearch">
      <div class="sousuo">
        <el-form
          ref="search"
          style="display: flex"
          :model="formInline"
          label-position="left"
          label-width="90px"
        >
          <el-form-item label="单位名称:">
            <el-input
              v-model="formInline.dwmc"
              placeholder="请输入完整的单位名称（必填）"
            />
          </el-form-item>
          <el-form-item label="申请类型:">
            <el-select v-model="formInline.ywlx" filterable placeholder="请选择（必填）">
              <el-option
                v-for="item in ywlxList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="化学品名称:">
            <el-input
              v-model="formInline.hxpMc"
              placeholder="请输入"
            />
          </el-form-item>
          <div>
            <el-button
              type="primary"
              icon="el-icon-search"
              round
              size="small"
              @click="loadDatasource()"
            >搜索</el-button>
            <el-button
              icon="el-icon-refresh-left"
              style="width: 90px; height: 39px"
              round
              size="small"
              @click="resetDataSource"
            >重置</el-button>
          </div>
        </el-form>
        <div>
          <span style="color: red">提示：1.除许可证相关申请查询外，其他申请尽量不使用化学品筛选；2.若查询结果为空，则在当前条件下不存在审批中的数据；3.内<->外网同步时间一个小时左右；</span>
        </div>
      </div>
    </div>
    <div style="margin: auto;
        width: 95%;
        max-width: 1518px;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 57px;">
      <div class="tablemes">
        <el-table
          :data="tableData"
          border
          :show-overflow-tooltip="true"
          :header-cell-style="{ background: '#F2F2F2' }"
          style="width: 100%"
        >
          <el-table-column
            prop="spjg"
            label="当前审批机关"
            />
          <el-table-column
            prop="spjs"
            label="当前审批角色"
            />
          <el-table-column
            prop="sqsj"
            label="申请时间"
            />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import {getSpxxDto} from "@/assets/js/system";

export default {
  name:'CxSplcSl',
  data(){
    return {
      formInline: { // 搜索表单
        dwmc: '',
        ywlx: '',
        hxpMc: '',
      },
      tableData: [], // 表格数据
      ywlxList:[
        {
          label: '企业入网申请',
          value: '11'
        },
        {
          label: '企业信息变更',
          value: '12'
        },
        {
          label: '主管理员变更',
          value: '13'
        },
        {
          label: '从业人员信息审批',
          value: '14'
        },
        {
          label: '增溢入库申请',
          value: '43'
        },
        {
          label: '损耗出库申请',
          value: '44'
        },
        {
          label: '其他出库申请',
          value: '45'
        },
        {
          label: '其他入库申请',
          value: '46'
        },
        {
          label: '购买证新增申请',
          value: '21'
        },
        {
          label: '购买证取消核销申请',
          value: '25'
        },
        {
          label: '运输证新增申请',
          value: '31'
        },
        {
          label: '运输证取消核销申请',
          value: '35'
        },
        {
          label: '出入库数量变更申请',
          value: '41'
        },
        {
          label: '移库数量变更申请',
          value: '42'
        },
        {
          label: '运输报备变更申请',
          value: '51'
        },
        {
          label: '仓库信息确认',
          value: '011'
        },
        {
          label: '责任书确认',
          value: '012'
        }
      ],
    }
  },
  mounted() {
  },
  methods:{
    // 查询列表数据
    loadDatasource() {
      getSpxxDto(this.formInline).then((e) => {
        if(e.status == 200){
          this.$message.success('查询成功!')
          this.tableData = e.data.data
        }
      })
    },
    // 重置
    resetDataSource() {
      this.formInline = {
        dwmc: '',
        ywlx: '',
        hxpMc: '',
      }
      this.tableData = []
      this.total = 0
    },
  }
}
</script>

<style scoped lang='less'>
  .CxSplcSlHome {
    // height: 100%;
    // width: 90%;
    // background-color: white;
    // margin: auto;
    .headerSearch {
      max-width: 1518px;
      width: 95%;
      margin: auto;
      margin-bottom: 11px;
      margin-top: 30px;
      background-color: white;
      padding: 30px 0 20px 0;
      // border: 1px solid red;
      display: flex;
      align-items: center;
      box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      .el-form-item {
        margin-bottom: 10px;
        margin-right: 30px;
        &:last-child {
          width: 90px;
          height: 39px;
          /deep/ .el-button {
            width: 90px !important;
            height: 39px;
            border-radius: 3px;
          }
        }
      }
    }
    .sousuo {
      width: 90%;
      margin-left: auto;
      margin-right: auto;
      .sousuoButton {
        width: 90px;
        height: 39px;
        background: #4170ff;
        border-color: #4170ff;
      }
      .chongzhiButton {
        width: 90px;
        height: 39px;
      }
    }
    .tablemes {
      margin: auto;
      width: 90%;
      max-width: 1375px;
      // margin-top: 21px;
      // margin-bottom: 57px;
      // /deep/ .el-table__header {
      //   .el-checkbox {
      //     display: none !important;
      //   }
      // }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;

        border: 1px solid #ebeef5;
        border-top: 0;
      }
      // .addButton {
      //   color: #fff;
      //   background: #4170ff;
      //   border-radius: 3px;
      //   border-color: #4170ff;
      // }
      .deleteButton {
        background: #ff5721 !important;
        border-color: #ff5721 !important;
      }
      .el-button--warning {
        color: #fff;
        background: #feb800;
        border-radius: 3px;
        border-color: #feb800;
      }
      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4170ff !important;
    color: #fff;
  }
  /deep/ .disableheadselection > .cell .el-checkbox__inner {
    display: none !important;
  }
</style>
